const defaultColumnsList = [
    {
        databaseName: 'first_name',
        label: 'First Name',
        name: 'first_name'
    },
    {
        databaseName: 'first_name',
        label: 'First Name',
        name: 'Given Name'
    },
    {
        databaseName: 'first_name',
        label: 'First Name',
        name: 'First Name'
    },
    {
        databaseName: 'first_name',
        label: 'First Name',
        name: 'firstName'
    },
    {
        databaseName: 'first_name',
        label: 'First Name',
        name: 'FirstName'
    },
    {
        databaseName: 'first_name',
        label: 'First Name',
        name: 'First_Name'
    },
    {
        databaseName: 'last_name',
        label: 'Last Name',
        name: 'Family Name'
    },
    {
        databaseName: 'last_name',
        label: 'Last Name',
        name: 'Last Name'
    },
    {
        databaseName: 'last_name',
        label: 'Last Name',
        name: 'last_name'
    },
    {
        databaseName: 'last_name',
        label: 'Last Name',
        name: 'lastName'
    },
    {
        databaseName: 'last_name',
        label: 'Last Name',
        name: 'LastName'
    },
    {
        databaseName: 'last_name',
        label: 'Last Name',
        name: 'Last_Name'
    },
    {
        databaseName: 'email',
        label: 'Email Address',
        name: 'email'
    },
    {
        databaseName: 'email',
        label: 'Email Address',
        name: 'E-mail 1 - Value'
    },
    {
        databaseName: 'email',
        label: 'Email Address',
        name: 'E-mail Address'
    },
    {
        databaseName: 'email',
        label: 'Email Address',
        name: 'email_address'
    },
    {
        databaseName: 'email',
        label: 'Email Address',
        name: 'Email_Address'
    },
    {
        databaseName: 'email',
        label: 'Email Address',
        name: 'emailAddress'
    },
    {
        databaseName: 'email',
        label: 'Email Address',
        name: 'EmailAddress'
    },
    {
        databaseName: 'phone',
        label: 'Phone Number',
        name: 'phone_number'
    },
    {
        databaseName: 'phone',
        label: 'Phone Number',
        name: 'Phone 1 - Value'
    },
    {
        databaseName: 'phone',
        label: 'Phone Number',
        name: 'Business Phone'
    },
    {
        databaseName: 'phone',
        label: 'Phone Number',
        name: 'Company Main Phone'
    },
    {
        databaseName: 'phone',
        label: 'Phone Number',
        name: 'phone'
    },
    {
        databaseName: 'phone',
        label: 'Phone Number',
        name: 'Phone'
    },
    {
        databaseName: 'phone',
        label: 'Phone Number',
        name: 'phoneNumber'
    },
    {
        databaseName: 'phone',
        label: 'Phone Number',
        name: 'PhoneNumber'
    },
    {
        databaseName: 'phone',
        label: 'Phone Number',
        name: 'Phone_Number'
    },
    {
        databaseName: 'company',
        label: 'Company',
        name: 'company'
    },
    {
        databaseName: 'company',
        label: 'Company',
        name: 'Company'
    },
    {
        databaseName: 'company',
        label: 'Company',
        name: 'Organization 1 - Name'
    },
    {
        databaseName: 'company',
        label: 'Company',
        name: 'company_name'
    },
    {
        databaseName: 'company',
        label: 'Company',
        name: 'Company_name'
    },
    {
        databaseName: 'company',
        label: 'Company',
        name: 'companyName'
    },
    {
        databaseName: 'company',
        label: 'Company',
        name: 'CompanyName'
    },
    {
        databaseName: 'gender',
        label: 'Gender',
        name: 'gender'
    },
    {
        databaseName: 'gender',
        label: 'Gender',
        name: 'Gender'
    },
    {
        databaseName: 'other_phone',
        label: 'Other Phone',
        name: 'other_phone'
    },
    {
        databaseName: 'other_phone',
        label: 'Other Phone',
        name: 'otherPhone'
    },
    {
        databaseName: 'other_phone',
        label: 'Other Phone',
        name: 'other phone'
    },
    {
        databaseName: 'other_phone',
        label: 'Other Phone',
        name: 'Other phone'
    },
    {
        databaseName: 'tags',
        label: 'Tags',
        name: 'tags'
    }
]

export default defaultColumnsList;